import { dmLookback } from '../../math/lookback'
import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'DM',
  version: 1,
  label: 'Directional Movement (+DM/−DM)',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 190,
  inputs: [period('timeperiod', 14)],
  outputs: [line('plus_dm', '+DM', COLOR.green), line('minus_dm', '−DM', COLOR.red)],
  talib: {
    functions: ['PLUS_DM', 'MINUS_DM'],
    expr: {
      plus_dm: 'PLUS_DM(high, low, timeperiod={timeperiod})',
      minus_dm: 'MINUS_DM(high, low, timeperiod={timeperiod})',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => dmLookback(timeperiod),
}
export default def
